<script>
    import Button from '@smui/button/styled';
    import Textfield from '@smui/textfield/styled';
    import { api_host, user_store, domain_code_store } from '../../stores';
    import { doFetch } from '../../utils/Fetching.js';
    import { onMount } from 'svelte';
    import { google_user } from '../../utils/auth.js';
    import { toast_message } from '../../utils/toast_message.js';
    import { querystring } from 'svelte-spa-router';


    let domain_code = '';
    domain_code_store.subscribe(value => {
        domain_code = value;
    });
    let redirect_code = {};
    let vc_id = "";
    let vc_code = "";
    let is_height_fit = true;
    onMount(async () => {
        const params = new URLSearchParams($querystring);
        if (params.has('redirect_code')) {
            redirect_code = JSON.parse(atob(params.get('redirect_code')));
        } else {
            window.location.href = '#/login';
        }
        if (window.innerHeight < 660) {
            is_height_fit = false;
        }
        const url = new URL(window.location.href.replace('#/register', ''));
        vc_id = url.searchParams.get('vc_id') || "null";
        vc_code = url.searchParams.get('vc_code') || "null";
    });
    user_store.subscribe(value => {
        if (value['is_authenticated']) window.location.href = '#/';
    });
    let email = "";
    let password = "";
    let first_name = "";
    let last_name = "";
    let checked = true;
    let register_state = true;
    let is_button_disabled = false;
    $: title = register_state ? "Register" : "Forgot / Reset password" 
    $: button_title = register_state ? "Register" : "Send password reset email" 
    const register = async () => {
        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!email.match(mailformat)) {
            toast_message(false, 'Invalid email address', 3000);
            return;
        }
        const lowerCaseLetters = /[a-z]/g;
        const upperCaseLetters = /[A-Z]/g;
        const numbers = /[0-9]/g;
        const missing_msg = [];
        if (!password.match(lowerCaseLetters)) missing_msg.push('A lowercase letter')
        if (!password.match(upperCaseLetters)) missing_msg.push('A capital letter')
        if (!password.match(numbers)) missing_msg.push('A number')
        if (password.length < 8) missing_msg.push('Minimum 8 characters')
        if (missing_msg.length > 0) {
            const error_msg = 'Password must contain:\n' + missing_msg.join('\n');
            toast_message(false, error_msg, 10000);
            return;  
        }
        if (first_name.length == 0 || last_name == 0) {
            toast_message(false, 'Invalid name', 3000);
            return;
        }
        is_button_disabled = true;
        const res = await doFetch(
            api_host + '/auth/register',
            'POST',
            {
                username: `${domain_code}${email}`.toLowerCase(),
                password: password,
                password2: password,
                email: email.toLowerCase(),
                first_name: first_name,
                last_name: last_name,
                plan_type: redirect_code['plan_type'],
                domain_name: redirect_code['subdomain'],
                vc_id: vc_id,
                vc_code: vc_code,
                role: 'landscaper'
            },
            { 'Content-Type': 'application/json', 'DomainCode': domain_code }
        );
        is_button_disabled = false;
        const { user, token } = res;
        if (token) {
            toast_message(true, 'Successfully registered', 2000);
            localStorage.setItem('HoyToKenTy', 'Token');
            localStorage.setItem('HoyToKenTo', token);
            localStorage.setItem('HoyDoMainCode', domain_code);
            window.location.href = '/';
        } else {
            toast_message(false, res[0] || res.non_field_errors || res.username || 'Registeration failed', 2000);
        }
    }
</script>

<div style={is_height_fit ? "height: 100%;" : "height: 100%;overflow-y: scroll"} id="form_container">
    <div class="formholder">
        <div class="companyimageholder">
            <a href="/"><img src="//via.placeholder.com/150" alt="company logo" /></a>
        </div>

        <div class="registerformholder">
            <div class="pagetitle registertitle">{title}</div>

            <div class="ff email">
                <Textfield 
                    required
                    type="email"
                    style="width: 100%;"
                    helperLine$style="width: 100%;" 
                    variant="outlined" 
                    bind:value={email}
                    label="Email Address"
                    name="user[email]"
                >
                </Textfield>            
            </div>

            <div class="ff name">
                <Textfield 
                    required
                    type="text"
                    style="width: 48%;"
                    helperLine$style="width: 100%;" 
                    variant="outlined" 
                    bind:value={first_name}
                    label="First Name"
                    name="user[first_name]"
                >
                </Textfield>
                <Textfield 
                    required
                    type="text"
                    style="width: 48%;"
                    helperLine$style="width: 100%;" 
                    variant="outlined" 
                    bind:value={last_name}
                    label="Last name"
                    name="user[last_name]"
                >
                </Textfield>
            </div>

            <div class="ff password">
                <Textfield 
                    required
                    type="password"
                    style="width: 100%;"
                    helperLine$style="width: 100%;" 
                    variant="outlined" 
                    bind:value={password}
                    label="Password"
                    name="user[password]"
                >
                </Textfield>            
            </div>

            <div class="ff buttonbar">
                <Button variant="raised" class="button-shaped-round" on:click={() => register()} disabled={is_button_disabled}>{button_title}</Button>
            </div>
        
            <div class="ff buttonbar">
                <Button variant="raised" class="button-shaped-round" style="background-color: #3f3f89;text-transform: none;" disabled={is_button_disabled} on:click={() => {
                    is_button_disabled = true;
                    Promise.resolve(google_user.signin()).then(async (res) => {
                        const { access_token, id_token } = res.xc;
                        const res_google_auth = await doFetch(
                            `${api_host}/auth/social/google/register`,
                            'POST',
                            {
                                access_token,
                                code: 'google',
                                id_token,
                                role: 'landscaper',
                                plan_type: redirect_code['plan_type'],
                                domain_name: redirect_code['subdomain'],
                                vc_id,
                                vc_code,
                                provider: 1
                            },
                            { 'Content-Type': 'application/json', 'DomainCode': domain_code }
                        );
                        is_button_disabled = false;
                        const { access_token: google_token } = res_google_auth;
                        if (!google_token) {
                            toast_message(false, res_google_auth.msg || 'Registeration failed', 2000);
                        } else {
                            toast_message(true, 'Successfully registered.', 2000);
                            localStorage.setItem('HoyToKenTy', 'Bearer');
                            localStorage.setItem('HoyToKenTo', google_token);
                            localStorage.setItem('HoyDoMainCode', domain_code);
                            window.location.href = '/';
                        }
                    });
                }}><img src="/img/Google-Icon.png" alt="google icon" width="28px">&nbsp;&nbsp;Sign up with Google</Button>
            </div>

            {#if $google_user}
                <h1 style="display: none;">{$google_user.profile.name}</h1>
            {/if}
            <div class="exception">
                <div class="ff signin">
                    <a on:click={() => window.location.href = '#/login'}>If you have an account? Sign In</a>
                </div>
            </div>
        </div>

    </div>
</div>

<style>
    :global(._toastMsg) {
        white-space: pre-line;
    }
    /* globals */
    .ff {
        padding: 10px;
    }
    .formholder {
        width: 500px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
    }
    .companyimageholder {
        width: 150px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 25px;
    }
    .companyimageholder img {
        width: 100%;
    }
	.name {
		display: flex;
        justify-content: space-between;
	}
    .exception {
        display: flex;
        justify-content: right;
    }
	
    .registerformholder {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        gap: 10px;
        grid-template-columns: repeat(2, 1fr);
        grid-template-areas: "pt pt"
                             "em em"
                             "pw pw"
                             "rm rm"
                             "bb bb"
                             "fp su";
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .formholder {
            width: 90%;
            margin-left: auto;
            margin-right: auto;
            margin-top: 50px;
        }
        .registerformholder {
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            gap: 10px;
            grid-template-columns: repeat(1, 1fr);
            grid-template-areas: "pt"
                                "em"
                                "pw"
                                "rm"
                                "bb"
                                "fp"
                                "su";
            }
            .forgotpassword, .signin {
                text-align: center;
            }
    }
    .pagetitle {
        grid-area: pt;
        padding-left: 10px;
    }
    .email {
        grid-area: em;
    }
    .password {
        grid-area: pw;
    }
    .rememberme {
        grid-area: rm;
    }
    .buttonbar {
        grid-area: bb;
    }
    * :global(.mdc-button) {
        width: 100% !important;
        color: white !important;
    }
    .forgotpassword {
        grid-area: fp;
        font-size: 14px;
    }
    * :global(a) {
        color: rgb(0, 179, 0) !important;
        cursor: pointer;
    }
    .signin {
        grid-area: su;
        font-size: 14px;
    }
</style>